/*******************************************************************************
 * Project：
 * Summary:
 *　　 Define multi-selectbox component directive
 * Remarks:
 *     multi selectbox component
 * History：
 *      NghiaNX            2021/04/26    Create
 ******************************************************************************/
import { Component, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Utility } from '../../utility/utility';
@Component({
  selector: 'app-multi-select-box',
  templateUrl: './multi-select-box.component.html',
  styleUrls: ['./multi-select-box.component.scss']
})
export class MultiSelectBoxComponent implements OnChanges {
  @Input() items: any[];
  @Input() isDisabled = false;
  @Output() eventSelectValue = new EventEmitter();
  showDropDown = false;
  disableBtn = false;
  checkNum: number;
  constructor(private util: Utility) { this.checkNum = 0; }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.util.isNullOrBlank(changes.items) && changes.items.currentValue.length > 0) {
      this.initLstItem();
    }
  }
  initLstItem() {
    for (const it of this.items) {
      it.check = true;
    }
    this.checkNum = this.items.filter(f => f.check).length - 1;
  }
  checkItem(idx: number) {
    let totalCheck = 0;
    switch (idx) {
      case 0:
        if (!this.items[idx].check) {
          this.items.map(m => m.check = true);
          totalCheck = this.items.length - 1;
        } else {
          this.items.map(m => m.check = false);
          totalCheck = 0;
        }
        break;
      default:
        if (!this.items[idx].check) {
          this.items[idx].check = true;
        } else {
          this.items[idx].check = false;
        }
        const lstChilds = this.items.slice(1);
        totalCheck = lstChilds.filter(f => f.check).length;
        if (totalCheck === lstChilds.length) {
          this.items[0].check = true;
        } else {
          this.items[0].check = false;
        }
        break;
    }
    this.checkNum = totalCheck;
  }
  shareCheckedlist() {
    this.showDropDown = false;
    this.eventSelectValue.emit(this.items);
  }
  focusSel() {
  }
}
